import { ThresholdTimeUnit } from 'src/app/interfaces/backend-models.interface';
import { SidenavEntry } from 'src/app/interfaces/workspace.interface';

/**
 * Converts a threshold configuration into a total number of milliseconds
 * @param timeNumber - The number of timeUnits for the threshold
 * @param timeUnits - The time unit for the threshold (minutes, hours, days)
 * @returns The number of milliseconds defined by the threshold configuration
 */
export function thresholdTimeToMs(timeNumber: number, timeUnits: string): number {
	if (!!timeNumber && !!timeUnits && timeUnits in ThresholdTimeUnit) {
		return timeNumber * ThresholdTimeUnit[timeUnits] * 1000;
	} else {
		return Infinity;
	}
}

/**
 * Check if a product has exceeded its configured threshold
 * @param product - product to check
 * @returns true if the threshold has been exceeded, false otherwise
 */
export function hasExceededThreshold(product: SidenavEntry): boolean {
	// Threshold must be enabled and configured
	if (
		product.thresholdConfig &&
		product.thresholdConfig.enabled &&
		product.lastHeardFrom &&
		product.thresholdConfig.timeNumber &&
		product.thresholdConfig.timeUnits
	) {
		// Threshold must be exceeded
		if (
			product.lastHeardFrom >= thresholdTimeToMs(product.thresholdConfig.timeNumber, product.thresholdConfig.timeUnits)
		) {
			return true;
		}
	}
	return false;
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
